'use client';

import { motion, LayoutGroup } from 'framer-motion';
import { cn } from '@/lib/utils';
import { resolveI18nText } from '@/sanity/globals/I18n';
import { IPricingAsset } from '@/sanity/lib/definitions';

const ease = [0.32, 0.72, 0, 1] as const;

export default function AssetTabs({
  assets,
  activeKey,
  onSelect,
  language,
  layoutId = 'pricing-asset-tabs',
}: {
  assets: IPricingAsset[];
  activeKey: string;
  onSelect: (key: string) => void;
  language?: string;
  layoutId?: string;
}) {
  return (
    <LayoutGroup id={layoutId}>
      <div className="inline-flex items-center p-[0.5rem] md:p-[0.75rem] rounded-[0.5rem] border border-black/10 bg-[#f4f4f4]">
        {assets.map((asset) => {
          const isActive = asset.key === activeKey;
          const label = resolveI18nText(asset.label, asset.labelI18n, language);
          return (
            <button
              key={asset.key}
              type="button"
              onClick={() => onSelect(asset.key ?? '')}
              className="relative px-[1.75rem] py-[1.5rem] md:px-[2.75rem] md:py-[2rem] rounded-[0.25rem] focus:outline-none focus-visible:ring-2 focus-visible:ring-black/40"
              aria-pressed={isActive}
            >
              {isActive && (
                <motion.span
                  layoutId={`${layoutId}-indicator`}
                  className="absolute inset-0 rounded-[0.25rem] border border-black/[0.14] bg-[#0d2922]"
                  transition={{ type: 'spring', bounce: 0.18, duration: 0.55 }}
                />
              )}
              <motion.span
                className="relative z-10 block text-[2rem] md:text-[2.75rem] leading-[1.3] tracking-[-0.04rem] md:tracking-[-0.055rem] font-geist font-medium whitespace-nowrap"
                animate={{
                  color: isActive ? '#ffffff' : '#000000',
                  opacity: isActive ? 1 : 0.5,
                }}
                transition={{ duration: 0.32, ease }}
              >
                {label}
              </motion.span>
            </button>
          );
        })}
      </div>
    </LayoutGroup>
  );
}
